import { ApplicationRef, createComponent, EmbeddedViewRef, EnvironmentInjector, inject, Injectable } from '@angular/core';
import { DlgBadBucketPositionComponent, DlgBadBucketPositionData } from './dlg-bad-bucket-position.component';
import { Scan } from '../../../model';

/**
 * Mounts DlgBadBucketPosition2Component directly to document.body as a
 * non-modal floating panel. Returns a destroy function for force-closing.
 */
@Injectable({ providedIn: 'root' })
export class BadBucketPanelService {
  private readonly appRef = inject(ApplicationRef);
  private readonly injector = inject(EnvironmentInjector);

  open(data: DlgBadBucketPositionData, onClose: (scan: Scan) => void): () => void {
    console.log('BadBucketPanelService.open()', { scanId: data.scan.id, seq: data.scan.sequenceInBatch });

    const ref = createComponent(DlgBadBucketPositionComponent, {
      environmentInjector: this.injector,
    });

    ref.setInput('scan', data.scan);
    ref.setInput('batch', data.batch);
    ref.setInput('isInViewMode', data.isInViewMode);

    this.appRef.attachView(ref.hostView);
    const domEl = (ref.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domEl);

    const destroy = () => {
      console.log('BadBucketPanelService: destroying panel');
      subscription.unsubscribe();
      this.appRef.detachView(ref.hostView);
      ref.destroy();
      domEl.remove();
    };

    const subscription = ref.instance.closed.subscribe((scan) => {
      destroy();
      onClose(scan);
    });

    return destroy;
  }
}
